import '@amzn/meridian-tokens/base/font/amazon-ember.css';
import './index.css';
import * as serviceWorker from './serviceWorker';
import bootstrap from './bootstrap';

bootstrap().catch(err => {
  // eslint-disable-next-line no-console
  console.error('Failed to bootstrap application', err);
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
